<template>
  <v-footer app :class="['footer-container', { 'footer-container-light': store.theme === 'light' }]">
    <div class="footer-content">
      <!-- Brand and Version -->
      <div class="brand-section">
        <img :src="'/' + store.fslabsLogo" alt="FSLabs" height="20" />
        <span class="version-text">v{{ version }}</span>
      </div>

      <!-- Links -->
      <div class="links-section">
        <a
          v-for="(link, index) in links"
          :key="index"
          :href="link.url"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-link"
        >
          <v-icon :icon="link.icon" size="small" />
          <span class="link-text">{{ link.text }}</span>
        </a>
      </div>
    </div>
  </v-footer>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { settingsService } from "../services";
import { isSuccess } from "../services/api";
import { useStore } from "../store/store";

const store = useStore();

// Version state
const version = ref("");

// Links configuration
const links = [
  {
    text: "FSLabs",
    icon: "mdi-web",
    url: "https://www.fslabs.ca/"
  },
  {
    text: "Dev",
    icon: "mdi-code-tags",
    url: "https://fsl.dev"
  }
];

onMounted(async () => {
  const result = await settingsService.getVersion();
  if (isSuccess(result)) {
    version.value = result.data.version;
  }
});
</script>

<style scoped>
.footer-container {
  background: rgba(14, 14, 16, 0.75) !important;
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-top: 1px solid rgba(50, 50, 56, 0.25);
  z-index: 5;
  min-height: 48px !important;
  max-height: 48px;
  padding: 0 16px;
}

/* Light theme: more transparent to show gradient background */
.footer-container-light {
  background: rgba(240, 240, 242, 0.8) !important;
  border-top: 1px solid rgba(0, 0, 0, 0.08) !important;
}

.footer-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}

.brand-section {
  display: flex;
  align-items: center;
  gap: 6px;
}

.version-text {
  font-size: 0.75rem;
  color: rgb(var(--v-theme-on-surface-variant));
  padding: 2px 6px;
  background: rgba(var(--v-theme-primary), 0.08);
  border-radius: 4px;
}

.links-section {
  display: flex;
  align-items: center;
  gap: 4px;
}

.footer-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  color: rgb(var(--v-theme-on-surface-variant));
  text-decoration: none;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.footer-link:hover {
  background: rgba(var(--v-theme-primary), 0.08);
  color: rgb(var(--v-theme-primary));
}

.footer-link .v-icon {
  font-size: 16px;
  opacity: 0.8;
}

.footer-link:hover .v-icon {
  opacity: 1;
}

.link-text {
  display: none;
}

/* Show text labels on medium screens and up */
@media (min-width: 600px) {
  .link-text {
    display: inline;
  }
}

@media (max-width: 600px) {
  .footer-container {
    padding: 0 12px;
  }

  .footer-link {
    padding: 6px 8px;
  }
}
</style>
